import {useField} from "react-final-form";

export function useIsCreateBooking() {
  const {input: {value: bookingId}} = useField<number>("bookingId", {subscription: {value: true}});

  return !bookingId;
}
